import React from 'react'

import { ErrorBoundary } from '@scoir/error-reporter'
import { ScrollTriggerContextProvider } from '@scoir/scroll-trigger'
import { Route, Switch } from 'react-router-dom'

import { AuthShieldContextProvider, AuthShieldRoute } from 'components/AuthShield'
import ManageSEOContextProvider from 'components/ManageSEO'
import ReactRouterProvider from 'components/ReactRouterProvider'
import ShareInterestProvider from 'components/ShareInterest/ShareInterestProvider'

import AuthRoutes from './AuthRoutes'
import UserStartup from './UserStartup'
import UserTrackingStartup from './UserTrackingStartup'

const RealtimeMessagingProvider = React.lazy(() => import('components/RealtimeMessagingProvider'))

const LazyRealtimeMessagingProvider = (props: React.ComponentProps<typeof RealtimeMessagingProvider>) => (
  <React.Suspense fallback={null}>
    <RealtimeMessagingProvider {...props} />
  </React.Suspense>
)
const Fragment = ({ children }: { children: React.ReactNode }) => <>{children}</>

export const AppStartup = () => {
  return (
    <AuthShieldContextProvider>
      <UserStartup>
        <ScrollTriggerContextProvider>
          <ReactRouterProvider>
            <ManageSEOContextProvider>
              <UserTrackingStartup>
                <AuthShieldRoute
                  authedComponent={LazyRealtimeMessagingProvider}
                  unauthedComponent={Fragment}
                  componentProps={{
                    children: (
                      <ShareInterestProvider>
                        <ErrorBoundary>
                          <Switch>
                            <Route component={AuthRoutes} />
                          </Switch>
                        </ErrorBoundary>
                      </ShareInterestProvider>
                    ),
                  }}
                />
              </UserTrackingStartup>
            </ManageSEOContextProvider>
          </ReactRouterProvider>
        </ScrollTriggerContextProvider>
      </UserStartup>
    </AuthShieldContextProvider>
  )
}
export default AppStartup
